module.exports = __webpack_public_path__ + "static/media/content_you_see.ea179117.svg";